import { type FC } from "react";
import { Center, VStack, Flex } from "@chakra-ui/react";
import { Box } from "@/components/essentials/box";
import { Button } from "@/components/essentials/button";
import { Typography } from "@/components/essentials/typography";
import { PasswordForm, NewPasswordForm, ConfirmPasswordForm } from "@/components/fragments/forms";
import { useFormContext } from "react-hook-form";
import {
  passwordChangeButtonTestId,
  passwordChangeTypographyDescriptionTestId,
  passwordChangeTypographyTitleTestId,
} from "./const";

interface PasswordChangeFormProps {
  readonly loading: boolean;
  readonly email: string | undefined;
}

export const PasswordChangeForm: FC<PasswordChangeFormProps> = ({ loading, email }) => {
  const {
    formState: { isValid },
  } = useFormContext();
  return (
    <Flex flexDir="column" gridGap="1.5rem">
      <Box>
        <Typography data-testid={passwordChangeTypographyTitleTestId} variant="display3">
          パスワードの変更
        </Typography>
        <Typography
          data-testid={passwordChangeTypographyDescriptionTestId}
          variant="text4"
          mt="0.25rem"
          color="dark.main"
        >
          お客様の大切な情報を守るため、パスワードは推測されにくい安全なものをご入力ください。
        </Typography>{" "}
      </Box>
      <VStack gridRowGap="1rem" alignItems="flex-start">
        <Box w="100%">
          <PasswordForm
            formLabel="現在のパスワード"
            placeholder="現在のパスワード"
            helperText="パスワードが入力されている"
          />
        </Box>
        <Box w="100%">
          <NewPasswordForm email={email} />
        </Box>
        <Box w="100%">
          <ConfirmPasswordForm />
        </Box>
      </VStack>
      <Center>
        <Button
          data-testid={passwordChangeButtonTestId}
          type="submit"
          my="3.75rem"
          size="lg"
          w="100%"
          disabled={!isValid || loading}
          isLoading={loading}
        >
          パスワードを変更する
        </Button>
      </Center>
    </Flex>
  );
};
